import React from "react"; 
import { Tag } from "antd";

// const OrderStatus = {
//   PENDING: "pending",
//   CONFIRMED: "confirmed",
//   CANCELLED: "cancelled",
// };

export const orderStatus = [
  { label: "En cours", value: "pending" },
  { label: "Confirmé", value: "confirmed" },
  { label: "Annulé", value: "cancelled" },
];

// export const orderStatus = Object.keys(OrderStatus).map((key) => ({
//   value: OrderStatus[key],
//   label: key,
// }));

export const getTagOrderStatus = (record) => {
  switch (record.order_status) {
    case "pending":
      return <Tag color="gold">Pending</Tag>;
    case "deposited":
      return <Tag color="blue">Deposited</Tag>;
    case "cancelled":
      return <Tag color="red">Cancelled</Tag>;
    case "confirmed":
      return <Tag color="green">Confirmed</Tag>;
    case "refund":
      return <Tag color="purple">Refund</Tag>;
    default:
      return <Tag>Waiting</Tag>;
  }
};
